import { toast } from 'react-toastify';
import { requestAxios } from 'services/api';
import { regulatoryInformationFactory } from 'factories';
import {
  CommonResponse,
  RegulatoryInformation,
  RegulatoryInformationForm,
} from 'types';

interface GetFormProps {
  store: string | null;
}

async function getForm({
  store,
}: GetFormProps): Promise<RegulatoryInformationForm | null> {
  if (store !== null) {
    const response = await requestAxios.get(`stores/${store}/psp-account`);

    return regulatoryInformationFactory(response.data);
  }

  toast.warn(`A loja precisa ser informada`);

  return null;
}

interface PostFormProps {
  store: string;
  params: RegulatoryInformation;
}

async function postForm({
  store,
  params,
}: PostFormProps): Promise<CommonResponse> {
  return await requestAxios.post(`stores/${store}/psp-account`, params, {
    headers: { 'Content-Type': 'application/json' },
  });
}

interface PostUpdateKycProps {
  store: string;
}

async function postUpdateKyc({ store }: PostUpdateKycProps) {
  return await requestAxios.post(`stores/${store}/know-your-customer`);
}

export const regulatoryService = {
  getForm,
  postForm,
  postUpdateKyc,
};
